// extracted by mini-css-extract-plugin
export default {"cls1":"DaIyKLpZMw2NyXDCL5XZ","cls2":"_3NQimtdW9hBgzTD8Ox9 DaIyKLpZMw2NyXDCL5XZ"};